import Helpers from '../modules/helpers';

const SideBar = {
    bindEvents: () => {
        if (document.getElementById('sib-sidebar')) {
            SideBar.sidebar();
            const blocks = document.getElementsByClassName('sib-block__section');
            blocks[0].classList.add('active');

        }
        if (document.getElementById('sib-sidebar2')) {

            SideBar.sidebarTwo();
            const blocksTwo = document.querySelectorAll("#downloads .sib-block__section");
            console.log(blocksTwo);
            //blocksTwo[0].classList.add('active')
        }

        SideBar.sidebarTabs();
    },
    sidebar: () => {
        document.addEventListener("scroll", () => {

            const element = document.getElementsByClassName('product__wrapper');
            const sidebar = document.getElementById('sib-sidebar').getBoundingClientRect().height;

            if( Helpers.getWindowSize().width > 991){


            if (element[0].getBoundingClientRect().top <= 100) {
                document.getElementById('sib-sidebar').classList.add('sib-sidebar--fixed');

            } else {
                document.getElementById('sib-sidebar').classList.remove('sib-sidebar--fixed');
                document.getElementById('sib-sidebar').classList.remove('sib-sidebar--bottom');
            }

            if (element[0].getBoundingClientRect().bottom - sidebar - 110 < 0) {
                document.getElementById('sib-sidebar').classList.remove('sib-sidebar--fixed');
                document.getElementById('sib-sidebar').classList.add('sib-sidebar--bottom');

            } else {
                document.getElementById('sib-sidebar').classList.remove('sib-sidebar--bottom');

            }
            }
        });
    },
    sidebarTabs: () => {
        const menu = document.getElementsByClassName('button--sidetab');

        for (let i = 0; i < menu.length; i++) {

            menu[i].addEventListener('click',  function (e) {
                e.preventDefault()
                const tabId = menu[i].getAttribute('data-tab');

                for (let k = 0; k < menu.length; k++) {
                    menu[k].classList.remove('active');
                }
                menu[i].classList.add('active');

                const blocks = document.getElementsByClassName('sib-block__section');
                for (let i = 0; i < blocks.length; i++) {
                    if(blocks[i].getAttribute('data-id') === tabId){
                        if(!blocks[i].classList.contains('active')){
                            blocks[i].classList.add('active');
                        }
                    }else{
                        blocks[i].classList.remove('active');
                    }
                }

            })

        }
    },
    sidebarTwo: () => {
        document.addEventListener("scroll", () => {
            if( Helpers.getWindowSize().width > 991) {
                const element = document.getElementsByClassName('product__wrapper');
                const sidebar = document.getElementById('sib-sidebar2').getBoundingClientRect().height;
                console.log(element[1].getBoundingClientRect().top);
                if (element[1].getBoundingClientRect().top <= 132) {
                    document.getElementById('sib-sidebar2').classList.add('sib-sidebar--fixed');

                } else {
                    document.getElementById('sib-sidebar2').classList.remove('sib-sidebar--fixed');
                }

                if (element[1].getBoundingClientRect().bottom - sidebar - 120 < 0) {
                    document.getElementById('sib-sidebar2').classList.remove('sib-sidebar--fixed');
                    document.getElementById('sib-sidebar2').classList.add('sib-sidebar--bottom');

                } else {
                    document.getElementById('sib-sidebar2').classList.remove('sib-sidebar--bottom');

                }
            }
        });
    },

};

module.exports = SideBar;


// WEBPACK FOOTER //
// ./src/js/partials/sidebar.js